import { useEffect, useState } from 'react';
import { MARKDOWN_TYPING_SPEED } from '../../helpers/progressgpt.constants';
import MarkdownView from '../MarkdownView/MarkdownView';

interface TypingMarkdownProps {
    message: string;
}
const TypingMarkdown = (props: TypingMarkdownProps) => {
    const { message } = props;

    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        let index = 0;
        const speed = MARKDOWN_TYPING_SPEED; // ms per character

        const interval = setInterval(() => {
            if (index <= message.length) {
                setDisplayedText(message.slice(0, index));
                index++;
            } else {
                clearInterval(interval);
            }
        }, speed);

        return () => clearInterval(interval);
    }, [message]);

    return <MarkdownView message={displayedText} />;
};

export default TypingMarkdown;
